// extracted by mini-css-extract-plugin
export default {"loadingContainer":"view_loadingContainer__qW5Gy","back":"view_back__xT8o7","loading":"view_loading__cwwF+"};